import { z } from 'zod';

/** Customer-side workspace root registered for Execution Agent scans. */
export const ProjectWorkspaceSchema = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  label: z.string().trim().min(1).max(120),
  /** Absolute path on the Execution Agent host (never read by SaaS). */
  rootPath: z.string().trim().min(1).max(500),
  repoId: z.string().uuid().nullable().optional(),
  /** Set when Execution Agent confirmed the path exists and is a directory. */
  pathVerifiedAt: z.string().nullable().optional(),
  pathVerifyError: z.string().nullable().optional(),
  /** Set when Analyze Application completed a scan for this workspace. */
  lastAnalyzedAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ProjectWorkspace = z.infer<typeof ProjectWorkspaceSchema>;

export const ListProjectWorkspacesResponseSchema = z.object({
  projectId: z.string().uuid(),
  workspaces: z.array(ProjectWorkspaceSchema),
});
export type ListProjectWorkspacesResponse = z.infer<typeof ListProjectWorkspacesResponseSchema>;

export const CreateProjectWorkspaceRequestSchema = z.object({
  label: z.string().trim().min(1).max(120),
  rootPath: z.string().trim().min(1).max(500),
  repoId: z.string().uuid().optional(),
});
export type CreateProjectWorkspaceRequest = z.infer<typeof CreateProjectWorkspaceRequestSchema>;

export const CreateProjectWorkspaceResponseSchema = z.object({
  workspace: ProjectWorkspaceSchema,
});
export type CreateProjectWorkspaceResponse = z.infer<typeof CreateProjectWorkspaceResponseSchema>;

export const WorkspaceScanRequestSchema = z.object({
  workspaceId: z.string().uuid(),
});
export type WorkspaceScanRequest = z.infer<typeof WorkspaceScanRequestSchema>;

export const WorkspaceScanResponseSchema = z.object({
  jobId: z.string().uuid(),
  workspaceId: z.string().uuid(),
  status: z.enum(['queued']),
});
export type WorkspaceScanResponse = z.infer<typeof WorkspaceScanResponseSchema>;
